import PocketBase from 'pocketbase';

const pb = new PocketBase('https://housedesigns99.com');
pb.autoCancellation(false);

// Sync authStore changes into our localStorage key
pb.authStore.onChange((token, model) => {
  if (token && model) {
    localStorage.setItem('pb_auth', JSON.stringify({ token, model }));
  } else {
    localStorage.removeItem('pb_auth');
  }
});

// One-time restore from our custom key (fallback if SDK persistence missed)
try {
  const stored = localStorage.getItem('pb_auth');
  if (stored && !pb.authStore.isValid) {
    const parsed = JSON.parse(stored);
    if (parsed.token && parsed.model) {
      pb.authStore.save(parsed.token, parsed.model);
    }
  }
} catch (_) {}

export default pb;
